const STATES = [
  { id: 'ready',   label: 'Ready',   color: '#16a34a', bg: '#dcfce7', desc: 'Available to receive calls' },
  { id: 'break',   label: 'Break',   color: '#d97706', bg: '#fef3c7', desc: 'Short break — not receiving calls' },
  { id: 'wrapup',  label: 'Wrap-up', color: '#7c3aed', bg: '#ede9fe', desc: 'Completing post-call work' },
  { id: 'offline', label: 'Offline', color: '#6b7280', bg: '#f3f4f6', desc: 'Signed out of queues' },
];

export default function MyStatePage({ agentState, onStateChange, queueName }) {
  const current = STATES.find(s => s.id === agentState) || STATES[0];

  return (
    <div style={{ padding: '24px' }}>
      <div className="admin-page-title">My State</div>
      <div className="admin-page-subtitle">Queue: {queueName || 'default'}</div>

      {/* Current state indicator */}
      <div style={{
        background: current.bg,
        borderRadius: '20px',
        padding: '32px',
        marginBottom: '28px',
        textAlign: 'center',
        border: `2px solid ${current.color}22`,
      }}>
        <div style={{
          width: 20, height: 20,
          borderRadius: '50%',
          background: current.color,
          margin: '0 auto 14px',
          boxShadow: `0 0 0 6px ${current.color}33`,
          animation: agentState === 'ready' ? 'ce-pulse 2s ease-in-out infinite' : 'none',
        }} />
        <div style={{ fontSize: '32px', fontWeight: 800, color: current.color }}>{current.label}</div>
        <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '6px' }}>{current.desc}</div>
      </div>

      {/* State buttons */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        {STATES.map(s => (
          <button
            key={s.id}
            onClick={() => onStateChange && onStateChange(s.id)}
            disabled={agentState === s.id}
            style={{
              padding: '20px',
              borderRadius: '16px',
              border: agentState === s.id ? `2px solid ${s.color}` : '2px solid #e5e7eb',
              background: agentState === s.id ? s.bg : 'white',
              color: agentState === s.id ? s.color : '#374151',
              fontWeight: agentState === s.id ? 800 : 600,
              fontSize: '15px',
              textAlign: 'left',
              cursor: agentState === s.id ? 'default' : 'pointer',
              transition: 'all 0.15s',
              opacity: agentState === s.id ? 1 : 0.85,
            }}
            onMouseEnter={e => { if (agentState !== s.id) e.currentTarget.style.borderColor = s.color; }}
            onMouseLeave={e => { if (agentState !== s.id) e.currentTarget.style.borderColor = '#e5e7eb'; }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ width: 10, height: 10, borderRadius: '50%', background: s.color, display: 'inline-block', flexShrink: 0 }} />
              {s.label}
              {agentState === s.id && (
                <span style={{ marginLeft: 'auto', fontSize: '11px', fontWeight: 700, background: s.color, color: 'white', padding: '2px 8px', borderRadius: '999px' }}>
                  CURRENT
                </span>
              )}
            </div>
            <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '5px', paddingLeft: '20px' }}>
              {s.desc}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
